<template>
  <div class="index" style="padding-top: 1rem" v-cloak>
    <div class="header acea-row row-center-wrapper">
      <div class="logo"><img :src="logoUrl" /></div>
      <!--<router-link :to="'/search'" class="search acea-row row-middle">-->
        <!--<span class="iconfont icon-xiazai5"></span>搜索-->
      <!--</router-link>-->

      <div class="online">online {{online_num}}</div>
    </div>
    <div class="banner-wrap">
      <div class="slider-banner banner">
        <swiper :options="swiperOption" v-if="banner.length > 0">
          <swiper-slide v-for="(item, index) in banner" :key="index">
            <router-link
              :to="item.wap_url ? item.wap_url : ''"
              class="search acea-row row-middle"
            >
              <img :src="item.pic" />
            </router-link>
          </swiper-slide>
          <div class="swiper-pagination paginationBanner" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <!-- 分类入口 未启用 -->
    <!-- <div class="nav acea-rownav acea-row" style="display: none;">
      <router-link
        :to="item.wap_url ? item.wap_url : ''"
        class="item"
        v-for="(item, index) in menus"
        :key="index"
      >
        <div class="pictrue"><img :src="item.pic" /></div>
        <div>{{ item.name }}</div>
      </router-link>
    </div> -->

    <!-- 新闻速递 轮播 -->
    <div class="news acea-row row-between-wrapper">
      <div class="pictrue"><img src="@assets/images/news.png" /></div>
      <!--<div class="pictrue">Notice</div>-->
      <div class="swiper-no-swiping new-banner">
        <swiper
          class="swiper-wrapper"
          :options="swiperRoll"
          v-if="roll.length > 0"
        >
          <!--vip 促销成功播报-->
          <swiper-slide
                  class="swiper-slide"
                  v-for="(item, index) in msgList"
                  :key="index"
          >
            <div class="acea-row row-between-wrapper">
              <div class="text acea-row row-between-wrapper">
                <div class="newsTitle line2">{{ item.content }}</div>
              </div>
            </div>
          </swiper-slide>

          <!--商城公告-->
          <!--<swiper-slide-->
            <!--class="swiper-slide"-->
            <!--v-for="(item, index) in roll"-->
            <!--:key="index"-->
          <!--&gt;-->
            <!--<router-link-->
              <!--:to="item.wap_url ? item.wap_url : ''"-->
              <!--class="acea-row row-between-wrapper"-->
            <!--&gt;-->
              <!--<div class="text acea-row row-between-wrapper">-->
                <!--<div class="label" v-if="item.show === '是'">最新</div>-->
                <!--<div class="newsTitle line1">{{ item.info }}</div>-->
              <!--</div>-->
              <!--&lt;!&ndash; <div class="iconfont icon-xiangyou"></div> &ndash;&gt;-->
            <!--</router-link>-->
          <!--</swiper-slide>-->
        </swiper>
      </div>
      <!--商城公告轮播模式时启用 更多-->
      <!--<div class="news_more">更多</div>-->
    </div>
     <!-- 拼团 秒杀 砍价 未启用 -->
    <!-- <div style="display: none;"
      class="specialArea acea-row row-between-wrapper"
      v-if="activityOne.wap_link !== undefined || activity.length"
    >
      <router-link
        :to="activityOne.wap_link ? activityOne.wap_link : ''"
        v-if="activityOne.wap_link !== undefined"
        class="assemble"
      >
        <img :src="activityOne.pic" />
        <div class="text">
          <div class="name">{{ activityOne.title }}</div>
          <div class="infor">{{ activityOne.info }}</div>
        </div>
      </router-link>
      <div class="list acea-row row-column-between">
        <router-link
          :to="item.wap_link ? item.wap_link : ''"
          class="item"
          v-for="(item, index) in activity"
          :key="index"
        >
          <img :src="item.pic" />
          <div class="text">
            <div class="name">{{ item.title }}</div>
            <div class="infor">{{ item.info }}</div>
          </div>
        </router-link>
      </div>
    </div> -->
     <!-- 装饰 家具 灯具 横向商品分类轮播 未启用 -->
    <div class="wrapper" v-if="info.fastList.length > 0 && false">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">Fast select</div>
          <div class="line1">{{ info.fastInfo }}</div>
        </div>
        <router-link :to="'/category'" class="more"
          >More<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="scroll-product">
        <swiper class="swiper-wrapper" :options="swiperScroll">
          <swiper-slide
            v-for="(item, index) in info.fastList"
            :key="index"
            class="swiper-slide"
          >
            <router-link
              :to="{
                path: '/goods_list',
                query: { id: item.id, title: item.cate_name }
              }"
            >
              <div class="img-box">
                <img :src="item.pic" />
              </div>
              <div class="pro-info line1">{{ item.cate_name }}</div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>
     <!--精品推荐 带轮播图 一行一个商品展示 未启用 -->
    <!-- <div
      class="wrapper"
      v-if=" info.bastList.length > 0 || info.bastBanner.length > 0 "
    >
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">精品推荐</div>
          <div class="line1">{{ info.bastInfo }}</div>
        </div>
        <router-link :to="{ path: '/hot_new_goods/' + 1 }" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="slider-banner boutique">
        <swiper class="swiper-wrapper" :options="swiperBoutique">
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in info.bastBanner"
            :key="index"
          >
            <router-link :to="item.wap_link ? item.wap_link : ''"
              ><img :src="item.img"
            /></router-link>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination paginationBoutique"></div>
      </div>
      <Good-list :good-list="info.bastList" :is-sort="false"></Good-list>
    </div> -->

    <div class="index-hotlist" v-if="indexGoods.length > 0">
      <div class="hot-title">
        HOT SPOT®
        <router-link :to="{ path: '/goods_list'}" class="more">
          All goods<span class="iconfont icon-jiantou"></span>
        </router-link>
      </div>
      <div class="hot-list">
        <router-link
        :to="{ path: '/detail/' + item.id }"
        class="hot-item"
        v-for="(item, index) in indexGoods"
        :key="index"
      >
        <div class="hot-img">
          <img class="goods-img" style="width: 100%;height: 3.43rem;" :src="item.image" />
        </div>
        <div style="padding: 0.28rem;box-sizing: border-box;">
          <div class="name line1">{{ item.store_name }}</div>
          <div class="money font-color-red">
            ₱<span class="num">{{ item.price }}</span>
          </div>
        </div>
      </router-link>
      </div>
    </div>
    <!-- 促销分类 -->
    <div class="footer-banner boutique">
      <div class="title">Promotion Type</div>
      <swiper class="footer-swiper" :options="swiperScrollFooter">
        <swiper-slide
          class="swiper-slide"
          v-for="(item, index) in info.bastBanner"
          :key="index"
        >
          <router-link :to="item.wap_link ? item.wap_link : ''"
            ><img :src="item.img"
          /></router-link>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination paginationBoutique"></div>
    </div>
    <!-- 热门榜单  未启用 -->
    <!-- <div class="hotList"  v-if="likeInfo.length > 0">
      <div class="hot-bg">
        <div class="title acea-row row-between-wrapper">
          <div class="text line1">
            <span class="label">热门榜单</span>根据销量、搜索、好评等综合得出
          </div>
          <router-link :to="{ path: '/hot_new_goods/' + 2 }" class="more">
            更多<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
      </div>
      <div class="list acea-row row-middle">
        <router-link
          :to="{ path: '/detail/' + item.id }"
          class="item"
          v-for="(item, index) in likeInfo"
          :key="index"
        >
          <div class="pictrue">
            <img :src="item.image" />
            <img
              src="@assets/images/one.png"
              class="numPic"
              v-if="index === 0"
            />
            <img
              src="@assets/images/two.png"
              class="numPic"
              v-else-if="index === 1"
            />
            <img
              src="@assets/images/three.png"
              class="numPic"
              v-else-if="index === 2"
            />
          </div>
          <div class="name line1">{{ item.store_name }}</div>
          <div class="money font-color-red">
            ₱<span class="num">{{ item.price }}</span>
          </div>
        </router-link>
      </div>
    </div> -->
    <!-- banner图一张 -->
    <!-- <div v-if="lovely.img" >
      <div class="adver">
        <img :src="lovely.img" />
      </div>
    </div> -->
    <!--新品首发 未启用  -->
    <!-- <div class="wrapper"  v-if="info.firstList.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">
            首发新品<span class="new font-color-red">NEW~</span>
          </div>
          <div class="line1">{{ info.firstInfo }}</div>
        </div>
        <router-link :to="{ path: '/hot_new_goods/' + 3 }" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="newProducts">
        <swiper class="swiper-wrapper" :options="swiperProducts">
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in info.firstList"
            :key="index"
          >
            <router-link :to="{ path: '/detail/' + item.id }">
              <div class="img-box">
                <img :src="item.image" />
              </div>
              <div class="pro-info line1">{{ item.store_name }}</div>
              <div class="money font-color-red">₱{{ item.price }}</div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div> -->
    <!-- 促销 未启用 -->
    <!-- <div class="wrapper"  v-if="benefit.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">促销单品</div>
          <div class="line1">{{ info.salesInfo }}</div>
        </div>
        <router-link :to="'/promotion'" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
    </div> -->

    <!-- 促销列表 -->
    <!-- <Promotion-good :benefit="benefit" ></Promotion-good> -->

    <!--一元购-->
    <!-- <div class="game-banner">
      <router-link :to="{ path: 'raiders/list/0'}" class="game-banner-item">
        <img src="../../assets/images/oneWin.jpg" alt="">
      </router-link>
    </div> -->

    <Friends :list="friend"></Friends>
    <Coupon-window
      :coupon-list="couponList"
      v-if="showCoupon"
      @checked="couponClose"
      @close="couponClose"
    ></Coupon-window>
    <div style="height:1.2rem;"></div>

  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import GoodList from "@components/GoodList";
import PromotionGood from "@components/PromotionGood";
import CouponWindow from "@components/CouponWindow";
import Friends from "@components/Friends";
import { getHomeData, getShare,getFriendsBanner,getServeMsg } from "@api/public";
import  {getUserInfo} from "@api/user";
import { getProducts } from "@api/store";

import cookie from "@utils/store/cookie";


import { openShareAll } from "@libs/wechat";
import { isWeixin } from "@utils/index";

const HAS_COUPON_WINDOW = "has_coupon_window";

export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    GoodList,
    PromotionGood,
    CouponWindow,
    Friends
  },
  props: {},
  data: function() {
    return {
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      where: {
        page: 1,
        limit: 8,
        // vip_limit:0,
        // keyword: s,
        sid: 4, //二级分类id
        // news: 0,
        // priceOrder: "",
        // salesOrder: ""
      },
      indexGoods:'',//首页展示的商品列表
      online_num:0,//在线人数
      friend:[],//友情链接
      msgList:[],//vip上线，中奖播报播报
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: []
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperScrollFooter: {
        slidesPerView: 'auto',
          spaceBetween: 10,
      },
      swiperBoutique: {
        pagination: {
          el: ".paginationBoutique",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      }
    };
  },
  mounted: function() {
    let that = this;
    getHomeData().then(res => {
      that.logoUrl = res.data.logoUrl;
      that.$set(that, "banner", res.data.banner);
      that.$set(that, "menus", res.data.menus);
      that.$set(that, "roll", res.data.roll);
      that.$set(that, "activity", res.data.activity);
      if (res.data.activity.length) {
        var activityOne = res.data.activity.shift();
        that.$set(that, "activityOne", activityOne);
      }
      that.$set(that, "info", res.data.info);
      that.$set(that, "likeInfo", res.data.likeInfo);
      that.$set(
        that,
        "lovely",
        res.data.lovely.length ? res.data.lovely[0] : {}
      );
      that.$set(that, "benefit", res.data.benefit);
      that.$set(that, "couponList", res.data.couponList);
      that.localStorage.set("default_country_code",res.data.default_country_code)

      let v  = res.data.open_windows_version
      if(localStorage.getItem("v")!=v && v){
        localStorage.setItem("v",v)
        let msg  = res.data.open_windows_content
        let url  = res.data.open_windows_url
        if(url){
          this.$dialog.confirm({
            mes: msg,
            title: "The announcement",
            opts: [
              {
                txt: "Cancel",
                color: false,
                callback: () => {
                  return
                }
              },
              {
                txt: "To travel to",
                color: "#00C3F9",
                callback: () => {
                  that.$router.push({path:url})
                }
              }
            ]
          });
        }else {
          this.$dialog.confirm({
            mes: msg,
            title: "The announcement",
            opts: [
              {
                txt: "OK",
                color: "#00C3F9"
              }
            ]
          });
        }

      }



      this.online_num = res.data.inline_people
      that.setOpenShare();
      this.showCoupon =
        res.data.couponList.some(coupon => !coupon.is_use);
    });
    
     if(this.$store.state.app.token){
        getUserInfo().then(res=>{
          that.localStorage.set('is_promoter',res.data.is_promoter)
        })
      }
    this.getList()
    this.getMsg()
  },
  methods: {
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    getMsg(){
      getServeMsg().then(res=>{
        this.msgList = res.data
      })
    },
    getList(){
      getProducts(this.where).then(res=>{
        // console.log('首页展示的商品列表' ,res)
        this.indexGoods =  res.data

      })
      getFriendsBanner().then(res=>{
        // console.log('合作伙伴列表' ,res)
         this.friend = res.data;
      })
    },

    setOpenShare: function() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>
<style scoped>
.index {
  background-color: #fff;
}
.index .news .new-banner .text{
  width: 100%;
}
.index .news .new-banner .text .newsTitle{
  width: 100%;
}
.game-banner{
  width: 100%;
  height: 1.8rem;
  padding: 0 0.28rem;
  box-sizing: border-box;
  margin-bottom: 0.15rem;
}
.game-banner img{
  width: 100%;
  height: 100%;
  border-radius: 0.15rem;
}

  .online{
    width: 50%;
    text-align: right;
    color: #fff;
    line-height: 1rem;
    height: 1rem;
  }

</style>
